export default "__VITE_ASSET__Du5I_tQ3__"